import {API} from '@/app-core/api/Api'

export default {

  async Menu(tagId, data = {}, config = {}) {
    const Endpoint = API.Endpoint.Tag.Menu
    Endpoint.Path = Endpoint.Path.replace('{tagId}', tagId)

    const Data = data
    const Config = {...config}
    return await API.RESTRequest(Endpoint, Data, Config)
  }

}
